import { render, staticRenderFns } from "./EhsDonut.vue?vue&type=template&id=3e97bc31"
import script from "./EhsDonut.vue?vue&type=script&lang=js"
export * from "./EhsDonut.vue?vue&type=script&lang=js"
import style0 from "./EhsDonut.vue?vue&type=style&index=0&id=3e97bc31&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports